// react components
import React from 'react'
import Linkify from 'react-linkify'

// components
import {
} from 'components'

// data
import {
    contentTypeModelTypeSite,
    fieldTypeLayoutSite,
} from 'data'

// pages
import {
    DetailRow825,
    IconBlock825,
    ImageHelper825,
    PhoneNumberHelper825,
} from 'pages'

// serializers
import {
    ContentTypeDetailBlockFieldSetTypes,
    ContentTypeSettingsTypes,
    ContentTypeSettingsCustomTypes,
} from 'serializers/site'

// services
import {
    getDateWithFormatSite,
} from 'services'

// props
type DetailField825Props = {
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    contentTypeSettingsCustom: ContentTypeSettingsCustomTypes | undefined
    field: string
    fieldSetObject: ContentTypeDetailBlockFieldSetTypes
    object: any
    subContentTypeForced?: { id: number, name: string }
}

// main
export const DetailField825: React.FC<DetailField825Props> = React.memo(({
    field,
    contentTypeSettings,
    contentTypeSettingsCustom,
    fieldSetObject,
    object,
    subContentTypeForced,
}) => {

    const newColumn = field.split('__')[0]
    const fieldSettings = contentTypeSettings.field?.[newColumn]
    const fieldSettingsCustom = {
        ...contentTypeSettingsCustom?.field?.[field],
        ...contentTypeSettingsCustom?.fieldSubContentType?.[subContentTypeForced?.id || object.sub_content_type?.id]?.[field],
    }

    if (!fieldSettings) return (
        <DetailRow825
            fieldOptions={undefined}
            fieldSettings={fieldSettings}
            rowId='error 1'
            title={field}
            value='Error'
        />
    )

    const valueType = fieldTypeLayoutSite[fieldSettings.fieldType]

    let value = object[field]

    let valueFieldOptions = undefined
    if (valueType === 'array') {
        const valueField = field.split('__')[1] || 'name'
        valueFieldOptions = fieldSettings.fields?.[valueField]
    }
    const name = fieldSettingsCustom?.verboseName ||
        fieldSettingsCustom?.verboseName ||
        valueFieldOptions?.verboseName ||
        contentTypeSettings.field?.[field]?.verboseName
    const title = name || field
    const fieldOptions = fieldSetObject.fieldsOptions?.[field]

    if (valueType === 'array') {
        let valueField = field.split('__')[1] || 'name'
        if (field.startsWith('attributions_many_to_many_field_')) {
            const hasNameForForeignKey = object.attributions_list?.some((item: any) => item.hasOwnProperty('name_for_foreign_key'))
            if (valueField === 'name' && hasNameForForeignKey) {
                valueField = 'name_for_foreign_key'
            }
            return (
                <DetailRow825
                    fieldOptions={fieldOptions}
                    fieldSettings={fieldSettings}
                    rowId='array 1'
                    title={title}
                    value={object.attributions_list?.filter((obj: any) => obj.attribution_category === contentTypeSettingsCustom?.form?.fieldsOptions?.[field]?.selectUrlParams?.attribution_categories)?.map((val: any) => val?.[valueField]).join(', ')}
                />
            )
        }
        const hasNameForForeignKey = object[newColumn]?.some((item: any) => item.hasOwnProperty('name_for_foreign_key'))
        if (valueField === 'name' && hasNameForForeignKey) {
            valueField = 'name_for_foreign_key'
        }
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='array 2'
                title={title}
                value={object[newColumn]?.map((val: any) => val[valueField]).join(', ')}
            />
        )
    }

    if (valueType === 'boolean') {
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='boolean'
                title={title}
                value={value}
            >
                <i className={`detail-field-icon-825 ${value ? 'mo-new-icon-check-circle-solid' : 'mo-new-icon-times-solid'}`} />
            </DetailRow825>
        )
    }

    if (valueType === 'datetime') {
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='datetime'
                title={title}
                value={getDateWithFormatSite(
                    value,
                    fieldSettingsCustom?.layout?.dateFormat ||
                    fieldSettings.layout?.dateFormat ||
                    ((fieldSettings.fieldType === 'DateField' && object.date_type_choice) && (object.date_type_choice.id === 'y' ? 'YYYY' : (object.date_type_choice.id === 'm' ? 'MM/YYYY' : 'DD/MM/YYYY'))) ||
                    ((fieldSettings.fieldType === 'DateField' || object.date_only) && 'DD/MM/YYYY') ||
                    (fieldSettings.fieldType === 'DateTimeField' && 'DD/MM/YYYY HH:mm') ||
                    undefined
                )}
            />
        )
    }

    if (valueType === 'image') {
        let imgageSrc = value
        let imgageSrcLightBox = value
        if (fieldSetObject.blockTypeOther === 'main' && !['cover_image_2'].includes(field)) {
            imgageSrc = object.get_image_lq
            imgageSrcLightBox = object.get_image_hq
        }
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='image'
                title={title}
                value={value?.name}
            >
                <ImageHelper825
                    alt={object.name}
                    className={`detail-field-image-825${object[`${field}_svg`] ? ' svg' : ''}`}
                    dominant_color={object.get_dominant_color}
                    lightBox
                    lightBoxSrc={imgageSrcLightBox}
                    src={imgageSrc}
                />
            </DetailRow825>
        )
    }

    if (valueType === 'number') {
        if (fieldSettings.layout?.isCurrency || fieldSettings.layout?.isPercentage) {
            value = Number(value).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            return (
                <DetailRow825
                    fieldOptions={fieldOptions}
                    fieldSettings={fieldSettings}
                    rowId='number 1'
                    title={title}
                    // value={`${value} ${object.currency?.symbol}`}
                    value={`${value} ${fieldSettings.layout?.isCurrency ? '€' : '%'}`}
                />
            )
        }
        // value = Number(value).toLocaleString('fr')
        value = (typeof value !== 'undefined' && value !== null) ? Number(value) : value
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='number 2'
                title={title}
                value={value}
            />
        )
    }

    if (valueType === 'phonenumber') {
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='phonenumber'
                title={title}
                value={value}
            >
                <PhoneNumberHelper825
                    showFlag
                    value={value}
                />
            </DetailRow825>
        )
    }

    if (valueType === 'rich') {
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                isRich
                rowId='rich'
                title={title}
                value={value}
            >
                <div
                    className={field === 'template' ? 'default-margin' : ''}  // TODO dynamic
                    dangerouslySetInnerHTML={{ __html: value }}
                />
            </DetailRow825>
        )
    }

    if (valueType === 'text') {
        if (['ChoiceField', 'ForeignKey', 'GenericForeignKey', 'OneToOneField'].includes(fieldSettings.fieldType)) {
            value = object[field]?.name_for_foreign_key || object[field]?.name
        }
        if (fieldSettings.fieldType === 'JSONField') {
            return (
                <DetailRow825
                    fieldOptions={fieldOptions}
                    fieldSettings={fieldSettings}
                    rowId='text 2'
                    title={title}
                    value={JSON.stringify(value)}
                />
            )
        }
        if (object[`${field}_is_rich`]) {
            return (
                <DetailRow825
                    fieldOptions={fieldOptions}
                    fieldSettings={fieldSettings}
                    isRich
                    rowId='text 3'
                    title={title}
                    value={object[`${field}_rich`]}
                >
                    <div
                        className={field === 'template' ? 'default-margin' : ''}  // TODO dynamic
                        dangerouslySetInnerHTML={{ __html: object[`${field}_rich`] }}
                    />
                </DetailRow825>
            )
        }
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='text 4'
                title={title}
                value={value}
            >
                <Linkify componentDecorator={(decoratedHref, decoratedText, key) => <a key={key} href={decoratedHref} target='blank'>{decoratedText}</a>}>
                    {object[field]?.color ? <span style={{ color: object[field]?.color }}>{value}</span> : value}
                </Linkify>
            </DetailRow825>
        )
    }

    if (valueType === 'time') {
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='time'
                title={title}
                value={getDateWithFormatSite(
                    value,
                    fieldSettingsCustom?.layout?.dateFormat ||
                    fieldSettings.layout?.dateFormat ||
                    'HH:mm',
                    true,
                )}
            />
        )
    }

    if (valueType === 'url') {
        if (fieldSettings.layout?.isIcon && value) {
            return (
                <DetailRow825
                    fieldOptions={fieldOptions}
                    fieldSettings={fieldSettings}
                    rowId='url 1'
                    title={title}
                    value={value}
                >
                    <IconBlock825
                        edit={false}
                        iconClass='mo-new-icon-link-solid'
                        href={fieldSettings.layout.isHref ? value : undefined}
                        to={!fieldSettings.layout.isHref ? value : undefined}
                    />
                </DetailRow825>
            )
        }

        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='url 2'
                title={title}
                value={value}
            >
                <Linkify componentDecorator={(decoratedHref, decoratedText, key) => <a key={key} href={decoratedHref} target='blank'>{decoratedText}</a>}>
                    {value}
                </Linkify>
            </DetailRow825>
        )
    }

    if (valueType === 'mixed') {
        if (value?.field_type === 'BooleanField') {
            return (
                <DetailRow825
                    fieldOptions={fieldOptions}
                    fieldSettings={fieldSettings}
                    rowId='mixed 1'
                    title={title}
                    value={value.value}
                >
                    <i className={`detail-field-icon-825 ${value.value ? 'mo-new-icon-check-circle-solid' : 'mo-new-icon-times-solid'}`} />
                </DetailRow825>
            )
        }
        return (
            <DetailRow825
                fieldOptions={fieldOptions}
                fieldSettings={fieldSettings}
                rowId='mixed 2'
                title={title}
                value={value?.value}
            />
        )
    }

    return (
        <DetailRow825
            fieldOptions={fieldOptions}
            fieldSettings={fieldSettings}
            isError
            rowId='error 2'
            title={title}
            value={`Error: Missing valueType type ${fieldSettings.fieldType}`}
        />
    )
})
